// storageService.js

const StorageService = (() => {
  // This variable lives in the module scope — so it's shared across all imports
  let useLocal = true;
  //let useLocal = localStorage.getItem('rememberMe') === 'true';

  // Call this once after login or app init
  const setRememberMe = (remember) => {
    useLocal = remember;
    // persist the remember flag
    localStorage.setItem("rememberMe", remember);
  };

  const getRememberMe = () => useLocal;

  const getStorage = () => (useLocal ? localStorage : sessionStorage);

  const setItem = (key, value) => {
    getStorage().setItem(key, value);
  };

  const getItem = (key) => {
    return getStorage().getItem(key);
  };

  const removeItem = (key) => {
    getStorage().removeItem(key);
  };

  const clear = () => {
    getStorage().clear();
  };

  return {
    setRememberMe,
    getRememberMe,
    setItem,
    getItem,
    removeItem,
    clear,
  };
})();

export default StorageService;
